import BookFreeClassBtn from '@components/common/book-free-class-btn'
import CommonCarousel from '@components/common/carousel'
import { FastlyImage } from '@components/common/image'

type Card = {
  image: string
  heading: string
  description: string
}

const CARDS: Card[] = [
  {
    image: '/images/courses/math/cards/math-help.jpg',
    heading: 'Math help',
    description:
      "Whether your child is building foundations in the early grades, struggling to keep up with school homework, preparing for an upcoming exam, or wants to go deeper on a specific topic, every learning path on Codingal is built around your child's syllabus, pace, and academic goals, not a one-size-fits-all curriculum.",
  },
  {
    image: '/images/courses/math/cards/early-education.jpg',
    heading: 'Early education',
    description:
      "The concepts your child learns in early grades are the foundation for everything that follows. We make sure they're built right, with lessons that develop number sense, logical thinking, and a genuine curiosity for Math before the pressure kicks in.",
  },
  {
    image: '/images/courses/math/cards/homework-help.jpg',
    heading: 'Homework help',
    description:
      "Spending an hour on a problem that should take ten minutes? Our teachers don't just give answers. They find the gap, fix the understanding, and make sure your child can solve it on their own next time.",
  },
  {
    image: '/images/courses/math/cards/test-prep.jpg',
    heading: 'Test preparation',
    description:
      "Exam week shouldn't mean panic week. Our teachers identify exactly where your child is losing marks, drill the right concepts with timed practice, and build the confidence to walk into any test prepared, not just hopeful.",
  },
]

const responsive = {
  desktop: { breakpoint: { max: 4000, min: 1024 }, items: 1 },
  tablet: { breakpoint: { max: 1024, min: 640 }, items: 2 },
  mobile: { breakpoint: { max: 640, min: 0 }, items: 1 },
}

type Props = {
  urlQuery?: string
}

const LookingForMathHelp = ({ urlQuery }: Props) => {
  return (
    <section className="bg-blue-50 bg-opacity-25 py-12 lg:py-16 px-5">
      <div className="container mx-auto max-w-6xl">
        <div className="text-center mb-10">
          <h2 className="text-2xl lg:text-4xl font-600 leading-tight mb-4 text-grey max-w-4xl mx-auto">
            Looking for a specific Math help? We&apos;ve got it covered.
          </h2>
          <p className="text-base lg:text-lg text-grey max-w-4xl mx-auto">
            Maybe your child needs a strong foundation before the next grade.
            Maybe homework is eating up your evenings. Or maybe a big test is
            coming up and the anxiety is already setting in. Whatever brought
            you here, we&apos;ve built exactly for this.
          </p>
        </div>
        <CommonCarousel responsive={responsive} hasArrows>
          {CARDS.map((card, i) => (
            <div
              key={i}
              className="bg-white rounded-xl border-2 border-orange shadow-sm flex flex-col lg:flex-row h-full mx-2 overflow-hidden"
            >
              <div className="bg-orange-100 bg-opacity-30 flex items-center justify-center flex-shrink-0">
                <FastlyImage
                  src={card.image}
                  alt={card.heading}
                  width={550}
                  height={337}
                  className="w-full h-full md:h-auto md:w-auto object-cover"
                />
              </div>
              <div className="p-6 lg:p-8 flex flex-col gap-3 justify-center">
                <h3 className="text-2xl lg:text-4xl font-600 text-grey">
                  {card.heading}
                </h3>
                <p className="text-grey-800 text-xl leading-snug">
                  {card.description}
                </p>
              </div>
            </div>
          ))}
        </CommonCarousel>
        <div className="flex justify-center mt-8">
          <BookFreeClassBtn query={urlQuery} />
        </div>
      </div>
    </section>
  )
}

export default LookingForMathHelp
